import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AccountContext } from "../../../../store/AccountContext";
import { OnboardingContext } from "../../../../store/OnboardingContext";
import {
  APPLICATION_SOURCE_GIFTCARD,
  APPLICATION_STATUS,
} from "@booyaltd/core";

const SignUpStepSuccess = () => {
  const { application } = useContext(OnboardingContext);
  const { userProfile } = useContext(AccountContext);

  if (
    !userProfile ||
    !application ||
    application.status !== APPLICATION_STATUS.CONVERTED.toString()
  )
    return null;

  const { source } = application;

  console.log(application.status, source, userProfile.memberStatusId);

  if (source.toString() === APPLICATION_SOURCE_GIFTCARD) {
    return <Navigate to="/success/giftcard" replace />;
  }

  return <Navigate to={"/videos"} replace />;
};

export default SignUpStepSuccess;
